import Customers from 'components/customers';

const CustomerPage = () => {
  return <Customers />;
};

export default CustomerPage;
